import { foldSearchText } from '~/chords/DropdownSingleSelect/utils/foldSearchText';

/**
 * Split labels and queries on non-letter/non-number runs (spaces, hyphens,
 * slashes, parentheses, etc.) so "Hop" in "Hip-Hop/Rap (Genre)" is searchable.
 */
export const SEARCH_SPLIT_REGEX = /[^\p{L}\p{N}]+/u;

/**
 * Punctuation that joins letter/number runs when there is no space
 * (Hip-Hop, D.U.M.B., d/b/a, Children's, Drum'n'bass).
 * Includes hyphen, period, slash, apostrophe, and right single quote.
 */
export const SEARCH_JOINER_PUNCTUATION_REGEX = /[-./'\u2019]/g;

export const SEARCH_WHITESPACE_REGEX = /\s+/u;
export const SEARCH_WORD_REGEX = /[\p{L}\p{M}\p{N}]+/gu;

export function splitSearchWords(value: string): string[] {
  return value.split(SEARCH_SPLIT_REGEX).filter(Boolean);
}

export function compactSearchText(value: string): string {
  return foldSearchText(value.replace(SEARCH_JOINER_PUNCTUATION_REGEX, ''));
}

/**
 * True when a query chunk still contains punctuation (/, -, ', :, etc.).
 */
export function hasSearchPunctuation(value: string): boolean {
  return /[^\p{L}\p{N}\s]/u.test(value);
}

export const DROPDOWN_SEARCH_DEFAULT_MAX_LENGTH = 200;

/**
 * Sentinel value assigned to the pinned "Clear selection" Select.Item so it
 * participates in Radix's roving focus / typeahead. Intercepted in
 * DropdownSingleSelect's onValueChange before reaching the consumer.
 */
export const DROPDOWN_CLEAR_SENTINEL_VALUE = '__chords_dropdown_clear__';
